var exports = {
  "Q": "labelText__wziHHF",
};

module.exports = exports;
